import { useEffect, useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FreeGiftModal from '@/pages/home/components/FreeGiftModal';
import KnowledgeBase from './components/KnowledgeBase';

const KB_TITLE = "Knowledge Base | Gracie & Lily Adventures";
const KB_DESCRIPTION =
  "Explore the Gracie & Lily Adventures knowledge base: brand facts, the Bichon Frise sisters Gracie and Lily, the book collection, themes, formats and frequently asked questions.";
const KB_KEYWORDS =
  "Gracie and Lily, knowledge base, children's books, Bichon Frise, book collection, FAQ, bedtime stories, kids books ages 3-8";

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setPropertyMeta(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function KnowledgeBasePage() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.title = KB_TITLE;

    setMeta('description', KB_DESCRIPTION);
    setMeta('keywords', KB_KEYWORDS);

    setPropertyMeta('og:title', KB_TITLE);
    setPropertyMeta('og:description', KB_DESCRIPTION);
    setPropertyMeta('og:type', 'website');

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      canonical.setAttribute('href', 'https://gracieandlily.com/knowledge-base/');
    }

    return () => {
      // no JSON-LD script ownership here; KnowledgeBase manages its own schema
    };
  }, []);

  return (
    <div className="w-full min-h-screen">
      <Navbar onOpenModal={() => setShowModal(true)} />
      <main className="pt-20 md:pt-24">
        <KnowledgeBase />
      </main>
      <Footer />
      <FreeGiftModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}